<div class="stats text-blue-950 p-[15px]">
  <div class="flex justify-between items-center min-h-8">
    <h1 class="m-0 text-base font-normal font-sans [text-wrap:auto]">
      {{ data().title }}
    </h1>
  </div>
  <div
    class="pt-[7px] text-2xl font-normal text-center overflow-visible relative min-h-[80px] flex justify-center items-center"
    [class.pointer-events-none]="loading() || data().records === 0"
    [appTooltip]="tooltipTemplate"
    #modalContent
  >
    <ngx-gauge
      class="gauge-value-item__chart !flex justify-center"
      [ngClass]="{
        'opacity-20 blur-[0.1rem]': loading(),
        'blur-[0.1rem]': !loading() && data().records === 0
      }"
      [value]="data().value"
      [min]="data().minValue"
      [max]="data().maxValue"
      [type]="'arch'"
      [cap]="'butt'"
      [thick]="12"
      [margin]="20"
      [thresholds]="data().thresholds"
      [label]="data().numberLabel"
      [markers]="data().markers"
    />

    @if (loading()) {
      <div class="absolute flex flex-col items-center justify-center">
        <mat-spinner [diameter]="75"></mat-spinner>
      </div>
    } @else if (data().records === 0) {
      <span
        class="absolute inset-0 flex justify-center items-center text-[#666] font-semibold bg-white opacity-75"
        matTooltip="There is no data for this widget"
      >
        No Data Available
      </span>
    }
  </div>

  <div></div> <!-- Helps to center the gauge -->
</div>

<ng-template #tooltipTemplate>
  <div>
    <strong>{{ data().value }}</strong>
  </div>
</ng-template>
